export default "__VITE_ASSET__DX9hG7H3__"